import { font, colors, devices } from '../../config/theme';
import { width100, widthHeight100 } from '../../utils/jss-utils';

const style = {};

style.base = {
  // ...width100,
  // height: '65px !important',
  font: {
    size: font.sizes.medium,
    family: font.family
  },
  padding: '10px 15px',
  // paddingLeft: '40px',
  // paddingRight: '40px',
  transition: 'all .2s',
  '&:disabled': {
    cursor: 'not-allowed !important',
    opacity: '1 !important',
    border: `1px solid ${colors.lighterGray} !important`,
    backgroundColor: `${colors.lighterGray} !important `,
    '&:hover': {
      color: `${colors.white} !important `,
      border: `1px solid ${colors.lighterGray} !important`,
      backgroundColor: `${colors.lighterGray} !important `
    }
  },
  '&:hover': {
    cursor: 'pointer'
  }
};

style.fullWidth = {
  width: '100% !important',
  maxWidth: '100% !important'
};

style.fixed = {};
style.absolute = {};

style.fixed[devices.mobile] = {
  // position: 'absolute !important',
  position: 'fixed !important',
  bottom: '0px',
  left: '0px'
};

style.absolute[devices.mobile] = {
  // position: 'absolute !important',
  position: 'absolute !important',
  bottom: '0px',
  left: '0px'
};

style.fixedRight = {};

style.fixedRight[devices.mobile] = {
  position: 'fixed !important',
  bottom: '0px',
  right: '0px'
};

style.dark = {
  backgroundColor: colors.black,
  color: colors.white,
  border: 'none'
};

style.light = {
  backgroundColor: colors.white,
  border: `1px solid ${colors.black}`,
  color: colors.black
};

style.light[devices.mobile] = {
  border: `1px solid ${colors.black}`,
  '&:hover': {
    backgroundColor: colors.white,
    border: `1px solid ${colors.black}`,
    color: colors.black
  }
};

style.dark[devices.desktop] = {
  '&:hover': {
    backgroundColor: '#6164FF !important',
    color: colors.white
  }
};

style.light[devices.desktop] = {
  '&:hover': {
    backgroundColor: '#6164FF',
    border: `1px solid #6164FF`,
    color: `${colors.white}`
  }
};

style.warning = {
  border: `1px solid ${colors.red} !important`,
  color: colors.red
};

style.warning[devices.desktop] = {
  '&:hover': {
    opacity: '1 !important',
    color: colors.white,
    border: `1px solid ${colors.red} !important`,
    backgroundColor: `${colors.red}`
  }
};

style.base[devices.mobile] = {
  maxWidth: '100%',
  font: {
    weight: '400 !important'
  }
};

style.base[devices.desktop] = {
  maxWidth: '290px',
  font: {
    weight: font.weights.medium
  }
};

export default style;
